import { cn } from '@/lib/utils'
import styles from './loading-outline.module.scss'

export function LoadingOutline({ className }: { className?: string }) {
  return (
    <svg className={cn(styles.outline, className)} aria-hidden="true" focusable="false">
      <rect width="100%" height="100%" pathLength="100" />
    </svg>
  )
}
